import { z } from 'zod';

export const getReportingTemplatesByConditionSchema = z.array(
  z.object({
    id: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    code: z.string().optional(),
    name: z.string().optional(),
    functionality: z.number(),
    documentTypeId: z.string().uuid().optional(),
    documentType: z
      .object({
        id: z.string(),
        code: z.string(),
        name: z.string(),
        description: z.string(),
      })
      .optional(),
    isManager: z.boolean().optional(),
    isClient: z.boolean().optional(),
  })
);

export type GetReportingTemplatesResponse = z.infer<typeof getReportingTemplatesByConditionSchema>;
